import React from "react";
import { currentUser } from "../../../fb"

// reactstrap components
import {
    Card,
    CardBody,
    Row,
    Col,
    Button,
} from "reactstrap";

function Client(
    {
        caption,
        img,
        website,
        setDeleted,
        partner,
        setPartnerCard,
        flag,
        setFlag,
    }) {

    return (
        <>
            <Col md="2">
                <Card className="card-pricing"
                    style={{
                        width: "90%",
                        height: "90%",
                    }}
                >
                    <CardBody
                        style={{
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        {/* image is imported here */}
                        <img
                            alt={caption}
                            className="img"
                            src={img}
                        />
                        {/* Modals */}
                        {
                            currentUser() &&
                            // <CardBody>
                            <div className="space-top" >
                                <Row>
                                    <Col md={12} xs={12} lg={12} style={{ textAlign: "center" }}>
                                        <a
                                            data-number="1"
                                            href="#editPartner"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById("editPartner").scrollIntoView({
                                                    behavior: "smooth",
                                                    block: "start",
                                                    inline: "nearest",
                                                });
                                            }}
                                        >
                                            <Row>
                                                <Col>
                                                    <Button
                                                        className="btn"
                                                        color="info"
                                                        type="button"
                                                        onClick={() => {
                                                            setDeleted([])
                                                            setPartnerCard(partner)
                                                            setFlag(!flag)
                                                        }}
                                                    >
                                                        Edit
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </a>
                                    </Col>
                                    {/* {
                                    del &&
                                    <Col md={6} xs={6} lg={6} style={{ textAlign: "left" }}>
                                        <Button
                                            className="btn"
                                            color="danger"
                                            type="button"
                                            onClick={() => setSmallAlert(true)}
                                        >
                                            Delete
                                    </Button>
                                    </Col>
                                } */}
                                </Row>
                            </div>
                        }
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}

export default Client;